import type { AdaptedTemplate } from 'shared/api/common/schemas/templates/template'
export type TemplatesFetchStatus = 'idle' | 'loading' | 'succeeded' | 'failed'

export interface TemplatesListState {
  items: AdaptedTemplate[]
  fetchStatus: TemplatesFetchStatus
}

export const initialState: TemplatesListState = {
  items: [] as AdaptedTemplate[],
  fetchStatus: 'idle',
}

export interface CurrentTemplates {
  item: AdaptedTemplate | null
  fetching: boolean
  fetchingShare: boolean
  fetchingTitle: boolean
  fetchingDescription: boolean
  hash: string | null
  hasChanges: boolean
  error: string | null
}

export const CurrentTemplatesInitialState: CurrentTemplates = {
  item: null,
  fetching: false,
  fetchingShare: false,
  fetchingTitle: false,
  fetchingDescription: false,
  hash: null,
  hasChanges: false,
  error: null,
}
